import { useRealUserInfo } from 'state';
import styles from './UserSettingsPage.module.scss';

export default function UserSettingsPage() {
    const { emailAddress, fullName, accountId } = useRealUserInfo();

    return (
        <div className={styles.page}>
            <h2>User Info</h2>
            <div className={styles.userInfo}>
                <label>Name:</label>
                <div>{fullName}</div>
                <label>Email:</label>
                <div>{emailAddress}</div>
                <label>Account ID:</label>
                <div>{accountId}</div>
           </div>
        </div>
    )
}